
import Bunyan from 'bunyan';
const  log = Bunyan.createLogger({name: "ClassGroup"});

import { CLASS_GROUP, NONE } from '../constants/types';

import AutonumGenerator from '../util/autonum-generator';

import ClassOMat from '../class-o-mat/class-o-mat';


class ClassGroup { 

  TYPE = CLASS_GROUP;

  constructor() { 
    this._Classes = [];
  }

  add(id, Class) { 
    this._Classes[id] = Class;
    return Class;
  }

  delete(id) { 
    this._Classes[id] = NONE;
  }

  get(id=NONE) { 
    if (id === NONE) return this._Classes(id);

    return this._Classes[id];
  }

  classes(Classes=NONE) { 
    if (Classes === NONE) return this._Classes;
    
    this._Classes = Classes;
  }


}

export default ClassGroup;
